const lordWarPrefix = "/api/v1/lw";

const lordWarType = "lw"; 

const lwUrls = {
  steamplayers: {
    path: (name, id, pageNum, page, token) => {
      return `/players?name=${name}&id=${id}&num=${pageNum}&page=${page}&token=${token || ""}`;
    },
    method: "GET"
  },
  testingplayer: {
    path: (name, id, pageNum, page) => {
      return `/testingrecharge/records?name=${name}&id=${id}&num=${pageNum}&page=${page}`;
    },
    method: "GET"
  },
  refundTestingRecharge: {
    path: (id) => {
      return `/testingrecharge/refund/${id}`;
    },
    method: "GET"
  },
  playerSummary: {
    path: (id) => {
      return `/player/${id}/summary`;
    },
    method: "GET"
  },  
  playerBrief: {
    path: (id) => {
      return `/player/${id}/brief`;
    },
    method: "GET"
  },  
  steamplayerPuchase: {
    path: (id) => {
      return `/player/${id}/shopbuy`;
    },
    method: "GET"
  },
  passports: {
    path: (id) => {
      return `/player/${id}/passports`;
    },
    method: "GET"
  },
  playerQuests: {
    path: (id) => {
      return `/player/${id}/quests`;
    },
    method: "GET",
  }, 
  updatePlayerQuest: {
    path: () => {
      return `/player/updatequest`;
    },
    method: "POST",
  }, 
  recharge: {
    path: (id) => {
      return `/player/${id}/orders`;
    },
    method: "GET"
  },
  batchFixed: {
    path: (func)=>`/sys/${func}`,
    method: "GET"
  },
  steamplayerChickens: {
    path: (id) => {
      return `/player/${id}/chks`;
    },
    method: "GET"
  },
  playerLootProgress: {
    path: (id) => {
      return `/player/${id}/lootcnt`;
    },
    method: "GET"
  },
  createActiveCode: {
    path: "/activecode",
    method: "POST",
  },
  getAllActiveCode: {
    path: "/activecode/all",
    method: "GET",
  },
  getActiveCodeStatus: {
    path: "/activecode/status",
    method: "GET",
  },
  updateActiveCodeStatus: {
    path: "/activecode/status",
    method: "POST",
  },
  bannedList: {
    path: "/ban/list",
    method: "GET"
  },
  createBannedList: {
    path: "/ban/add",
    method: "POST"
  },
  deleteBannedDetail: {
    path: "/ban/del",
    method: "POST"
  },
  deleteSpecialDetail: {
    path: (id) => { return `/specialusers/${id}` },
    method: "GET"
  },
  addBlackList: {
    path: "/admin/blacklist",
    method: "POST"
  },
  getPlayerLogs: {
    path: (id) => {
      return `/player/${id}/logs`;
    },
    method: "GET"
  },
  getPlayerPreLogs: {
    path: (id) => {
      return `/player/${id}/prelogs`;
    },
    method: "GET"
  },
  chargeStatistias: {
    path: "/charge/statistics",
    method: "GET"
  },
  playerLeaderBoard: {
    path: (ppid) => {
      return `/admin/steamplayers/leaderboard/${ppid}`;
    },
    method: "GET"
  }, 
  unhandleorder: {
    path: (start, end) => {
      return `/charge/unhandlerorder?start=${start}&end=${end}`;
    },
    method: "GET"
  },
  getAllShopItem: {
    path: "/shop/items",
    method: "GET"
  },
  makeShopTicket: {
    path: "/shop/ticket",
    method: "POST"
  },
  getShopTicketDetail: {
    path: "/shop/ticket/detail",
    method: "GET"
  },
  closeVerifyCode: {
    path: "/admin/verifycode/status",
    method: "GET"
  },
  clearPlayerRedisCache: {
    path: (id) => `/player/${id}/clearcache`,
    method: "GET"
  },
  recentlyOrder: {
    path: "/charge/recently",
    method: "GET"
  },
  takeShopTicket: {
    path: "/shop/ticket/collect",
    method: "POST"
  },
  dailySummary: {
    path: (start, end) => `/daily/statistics?start=${start}&end=${end}`,
    method: "GET"
  },
  shopDailyReport: {
    path: (start, end) => `/shop/dailyreport?start=${start}&end=${end}`,
    method: "GET"
  },
  deletePlayer: {
    path: (id) => `/player/${id}`,
    method: "DELETE"
  },
  activePlayer: {
    path: (id) => `/player/${id}/active`,
    method: "GET"
  },
  playerRank: {
    path: "/player/leaderboard",
    method: "GET"
  },
  teamRank: {
    path: "/leaderboard/team",
    method: "GET",
  },
  equipRank: {
    path: "/leaderboard/equip",
    method: "GET"
  },
  getMatchStatistics: {
    path: (type) => {
      return `/match/statistics/${type}`;
    },
    method: "GET"
  }, 
  items:{
    path:"/order/items",
    method:"GET",
},
};


export { lordWarPrefix,lordWarType,lwUrls}
